import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { PageBlockTypes } from '../../pageBlocks'

export default defineType({
  title: 'Replacement Program',
  name: 'fiftyReplacement',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: [...PageBlockTypes],
      group: 'content',
    }),
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'heroSimple',
      group: 'content',
      hidden: true,
    }),
    defineField({
      title: 'YouTube Video',
      name: 'youtubeVideo',
      type: 'youtubeVideo',
      group: 'content',
      hidden: true,
    }),
    defineField({
      title: 'Info Cards',
      name: 'infoCards',
      type: 'infoCards',
      group: 'content',
    }),
    defineField({
      title: 'FAQ',
      name: 'faq',
      type: 'faq',
      group: 'content',
    }),
    defineField({
      title: 'Testimonials',
      name: 'testimonials',
      type: 'testimonials',
      group: 'content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})